var map = {
	"./1.jpg": 1736,
	"./2.jpg": 9970,
	"./3.jpg": 6224,
	"./4.jpg": 8746,
	"./5.jpg": 7496,
	"./6.jpg": 6715,
	"./hk.jpg": 9037,
	"./photo1.jpg": 1884,
	"./photo2.jpg": 9106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7714;